<template>
  <b-modal id="ModalTermos" no-close-on-esc no-close-on-backdrop size="xl">
    <Header mini titulo="Termos de uso" icone="file-signature" cor="azul" slot="modal-header" />

    <LoadingPadraoContainer
      v-if="loadingTermos"
      class="loading-padrao-backdrop"
      background
      :fraseLoading="['Aceitando termos de uso', 'Aguarde um momento']"
      delay="5000"
      classe="azul"
    />

    <div class="modal-termos-corpo">
      <p>
        A ECONET EDITORA EMPRESARIAL LTDA (“ECONET”), empresa brasileira com sede em Curitiba/PR, no
        endereço Rua Gago Coutinho, 553, Bacacheri, oferece produtos, incluindo
        aplicativos, plataformas e ferramentas tributárias, para aparelhos e dispositivos de forma
        <i>online</i>.
      </p>

      <p>
        O Revisor Tributário Econet (“RTE”) é um produto que dispõe da cadeia tributária conforme a
        operação simulada. Tem como propósito indicar a tributação das mercadorias de forma
        objetiva, de acordo com a legislação vigente em âmbito estadual e federal, considerando o
        cenário de cada USUÁRIO e seu regime tributário.
      </p>

      <p>
        Dispõe da tributação Estadual e Federal nas operações Interna, Interestadual, Importação e
        Exportação com mercadorias, abrangendo:
      </p>

      <ul>
        <li>
          <strong>ICMS:</strong> Alíquotas Específicas, Alíquota Regra Geral, Alíquotas
          Interestaduais, Benefícios (Isenção, Redução de Base de Cálculo e Crédito Presumido) não
          vinculados a regimes especiais de tributação que possuem Termo de Acordo, Não Incidência,
          Substituição Tributária (Base de cálculo: Pauta, MVA Original e recalculada, em vista da
          Alíquota ICMS-ST e da fruição de benefícios), Alíquota ICMS-ST, inclusive adicional nesta
          alíquota, CEST e Convênios e Protocolos, Carga Líquida (Somente Ceará), Antecipação
          Tributária com Encerramento da Fase de Tributação, Tratamento Específico quando da
          destinação à Zona Franca de Manaus ou às Áreas de Livre Comércio; Diferencial de Alíquotas
          de Contribuintes; Diferencial de Alíquotas de Não Contribuintes;
        </li>
        <li>
          <strong>Fundo de Combate à Pobreza:</strong> Alíquotas Específicas, Alíquota Regra Geral e
          Não Incidência;
        </li>
        <li>
          <strong>IPI:</strong> Fato Gerador, Hipóteses de Equiparação a Industrial, Tributada,
          Alíquota reduzida, Tributada com Alíquota Zero, Não Tributada (NT), Imunidade, Isenção,
          Suspensão e Bebidas Frias (Alíquotas, Redução da Alíquota, Pauta Mínima) e Tratamento
          Específico quando da destinação à Zona Franca de Manaus, Áreas de Livre Comércio ou às
          Amazônia Ocidental;
        </li>
        <li>
          <strong>PIS/COFINS:</strong> Alíquota Básica, Alíquota Diferenciada, Alíquota Zero,
          Adicional na Alíquota da COFINS-Importação, Alíquota Monofásica, Redução da Alíquota
          Monofásica, Monofásica por Unidade de Medida de Produto, Bebidas Frias (Alíquotas, Redução
          da Alíquota, Pauta Mínima), ​Não Incidência, Isenção, Suspensão, Substituição Tributária e
          Tratamento Específico quando da destinação à Zona Franca de Manaus (ZFM) ou às Áreas de
          Livre Comércio (ALC);
        </li>
        <li>
          <strong>Imposto de Importação:</strong> TEC, LETEC, LEBIT, Ex-Tarifários,
          Desabastecimento, GATT, Extrazona, Alíquota Específica, Imunidade, Isenção e Acordos
          Internacionais, Tratamento Específico quando da destinação à Zona Franca de Manaus, Áreas
          de Livre Comércio ou às Amazônia Ocidental;
        </li>
        <li><strong>Imposto de Exportação:</strong> Alíquotas e Não Incidência;</li>
        <li>
          <strong>Acordos Internacionais:</strong> Preferência Tarifária na importação e na
          exportação;
        </li>
        <li><strong>CIDE-Combustíveis:</strong> Alíquotas e Não Incidência;</li>
        <li>
          <strong>Defesa Comercial:</strong> Compromisso de Preço, Medida Compensatória Geral,
          Medida Compensatória Individual, Medida Geral de Dumping e Não Incidência.
        </li>
      </ul>

      <br />

      <strong><u>DEFINIÇÕES:</u></strong>

      <br /><br />

      <p>
        INFORMAÇÃO CONFIDENCIAL: toda e qualquer referência à expressão “INFORMAÇÃO CONFIDENCIAL”
        deverá ser compreendida e interpretada como considerando todo e qualquer informação,
        conhecimento ou dado, revelado ao USUÁRIO, contendo ou não a expressão “CONFIDENCIAL”, de
        maneira verbal, escrita ou de qualquer outro modo apresentado, de forma tangível ou
        intangível, dos quais venha a tomar conhecimento, ou que sejam descobertos pelo USUÁRIO
        durante a execução de atividades inerentes ao uso do RTE, ou decorrentes dessa execução, ou
        fornecido ou divulgado pela ECONET ao USUÁRIO, segundo este INSTRUMENTO ou em relação a ele,
        ou a qualquer outro instrumento celebrado entre o USUÁRIO e a ECONET, a que, diretamente ou
        através de terceiros, venha ter acesso, conhecimento ou que venha a lhe ser confiado,
        incluindo, mas não se limitando a:
      </p>

      <ul class="paddingLeftMenor">
        <li class="listStyleAlpha">
          <strong class="paddingRight">a)</strong> obras literárias, programas de computador e/ou
          outras obras autorais, bem como quaisquer outras informações e conteúdos envolvendo
          direitos de propriedade intelectual da ECONET, podendo incluir, mas não se limitando a:
          direitos autorais, marcas, <i>know-how</i>, segredos de negócio, desenhos industriais e/ou
          patentes; e/ou
        </li>
        <li class="listStyleAlpha">
          <strong class="paddingRight">b)</strong> modelos e estratégias de negócio, decisões
          gerenciais, oportunidades de mercado, planos de marketing e comerciais, informações de
          natureza publicitária, estudos e/ou pesquisas de mercado; e/ou
        </li>
        <li class="listStyleAlpha">
          <strong class="paddingRight">c)</strong> características, amostras, especificações e
          conceitos de produtos (pré-existentes, novos ou em desenvolvimento); e/ou;
        </li>
        <li class="listStyleAlpha">
          <strong class="paddingRight">d)</strong> informações referentes a operações, processos,
          planos ou intenções; e/ou
        </li>
        <li class="listStyleAlpha">
          <strong class="paddingRight">e)</strong> informações sobre produção, instalações,
          equipamentos, dados, habilidades especializadas, projetos, métodos e metodologia,
          fluxogramas, especificações, componentes, fórmulas, amostras, diagramas, layouts de
          diagramação, desenhos, modelos, esquemas industriais, questionários, invenções, ideias,
          conceitos, procedimentos normativos, sistemas; e/ou
        </li>
        <li class="listStyleAlpha">
          <strong class="paddingRight">f)</strong> listas de preços, listas de clientes, informações
          sobre negociações em andamento, informações cadastrais de clientes, fornecedores e/ou
          parceiros comerciais; e/ou
        </li>
        <li class="listStyleAlpha">
          <strong class="paddingRight">g)</strong> e-mails e/ou outras correspondências; e/ou
        </li>
        <li class="listStyleAlpha">
          <strong class="paddingRight">h)</strong> informações, demonstrações, apresentações,
          relatórios e/ou listas de natureza contábil, financeiro e/ou estatístico.
        </li>
      </ul>

      <p>
        TRATAMENTO DE DADOS (“TRATAMENTO”): toda operação realizada com dados pessoais, como as que
        se referem a coleta, produção, recepção, classificação, utilização, acesso, reprodução,
        transmissão, distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação
        ou controle da informação, modificação, comunicação, transferência, difusão ou extração;
      </p>

      <p>
        DADOS PESSOAIS (“DADOS PESSOAIS”) são todas informações relacionadas à pessoa natural
        identificada ou identificável. Dentro dessa definição, encontram-se os nomes dos USUÁRIOS,
        endereço de e-mail, número de telefone, informações identificadoras (IDs) de dispositivos;
      </p>

      <p>
        Revisor Tributário Econet (“RTE”): refere-se expressamente ao produto ali disponibilizados e 
        oferecidos ao USUÁRIO, cujo acesso se dá via navegador web ou dispositivos móveis.
      </p>

      <br />

      <strong>1. DO ESCOPO</strong>

      <p>
        Estes Termos e Condições de Uso (doravante referenciados simplesmente como “INSTRUMENTO”) 
        são aplicáveis a todos que acessarem, obterem uma cópia, fizerem download, e/ou utilizarem 
        os Produtos da ECONET, disponibilizados no site. Ressalta-se que não está autorizada a 
        utilização do SOFTWARE se não obtido dos meios oficiais oferecidos pela empresa.
      </p>

      <p>
        A ECONET concede licença pessoal, revogável, não exclusiva e intransferível para que o
        USUÁRIO faça uso do RTE, considerando os propósitos de simulação da cadeia tributária
        envolvendo a operação inserida no produto pelo USUÁRIO. O USUÁRIO não está autorizado a
        utilizar ou permitir que o RTE seja utilizado para finalidade diversa ao escopo do presente
        instrumento.
      </p>

      <p>
        Para a utilização de nossos produtos, é necessário que o USUÁRIO nos conceda algumas 
        permissões. Para tanto, é importante que esteja de acordo com as disposições integrais 
        de nossos Termos e Condições de Uso e Política de Privacidade.
      </p>

      <p>
        Caso não esteja de acordo com o disposto nos documentos mencionados acima, ou venha a mudar
        de ideia ao longo de sua experiência junta à ECONET, o USUÁRIO terá o direito de excluir a
        sua conta. A exclusão de sua conta e a remoção de eventuais dados relacionados a esta se
        dará de acordo com os limites técnicos envolvidos nessas práticas, bem como observará o
        disposto na legislação aplicável e na Política de Privacidade.
      </p>

      <br />

      <strong>2. ACESSO E USABILIDADE DO RTE</strong>

      <p>
        O produto será disponibilizado na área “Soluções Econet” do site da ECONET, com acesso
        através de <i>login</i> e senha do cliente. A ECONET prestará informações para a utilização
        da RTE, tanto para questões sistêmicas, quanto legislativas, sendo elas disponibilizadas por
        meios dos canais de consultoria (legislativo), Suporte Técnico (sistêmico), ou via manual e
        demais conteúdos disponibilizados sobre o assunto.
      </p>

      <p>
        O USUÁRIO poderá contatar a ECONET que disponibilizará auxílio e esclarecimento de dúvidas
        quanto a aplicação e utilização do produto através dos canais de comunicação dispostos pela
        ECONET.
      </p>

      <p>
        O RTE foi homologado para uso em computadores que utilizem o navegador Google Chrome, na
        versão 6 ou superior. Assim, para o melhor funcionamento da plataforma, os USUÁRIOS deverão
        utilizar tal navegador.
      </p>

      <p>
        A utilização da ferramenta em navegadores não-homologados, como, mas não somente, Internet
        Explorer, Firefox, Safari, etc., ou acesso via dispositivos móveis, poderá ocasionar danos
        às informações. A ECONET não se responsabiliza por danos, falhas, e/ou dificuldades no
        acesso ou uso da ferramenta no caso de uso de navegadores não homologados.
      </p>

      <P
        >Visando a constante atualização, assim como melhorias na funcionalidade e usabilidade da
        ferramenta, a ECONET poderá retirar o RTE do ar, momentaneamente, impossibilitando o acesso
        do USUÁRIO.</P
      >

      <p>
        Os acessos são de responsabilidade do utilizador da ferramenta, que deve tomar as devidas
        providências para garantir a confidencialidade da mesma, sendo seu uso restrito aos
        assinantes da ECONET, e não sendo permitido o repasse quanto a sua utilização por terceiros.
        A ECONET, periodicamente realizará verificações, e caso constatado alguma irregularidade
        quanto ao seu uso, serão tomadas as devidas providências, para fins de evitar o
        compartilhamento de acesso ou vazamento de informação.
      </p>

      <p>
        O RTE possui sincronização com o CNPJ, sendo realizada mediante validação pelo USUÁRIO do
        captcha disposto pelo portal da Receita Federal, sendo a ECONET mera facilitadora no consumo
        desta informação.
      </p>

      <br />

      <strong>3. ATUALIZAÇÕES</strong>

      <p>
        Visando promover uma melhor experiência aos USUÁRIOS no momento de utilizar os nossos produtos, 
        podemos atualizar e/ou modificar o SOFTWARE, os termos do presente INSTRUMENTO e da Política de 
        Privacidade para que eles reflitam as nossas práticas atuais, bem como estejam sempre conformidade 
        com a legislação aplicável.
      </p>

      <p>
        As alterações e atualizações realizadas no presente INSTRUMENTO serão devidamente comunicadas 
        anteriormente à sua entrada em vigor, para que o USUÁRIO tenha a oportunidade de analisar o seu 
        conteúdo e optar pela sua permanência ou não na utilização de nosso produto. Esperamos que o USUÁRIO 
        esteja sempre satisfeito com os resultados proporcionado pelos nossos produtos, entretanto, caso não 
        venha a concordar com os nossos Termos e Condições de Uso, o USUÁRIO terá toda a liberdade para 
        excluir a conta a qualquer momento. Uma vez que os Termos atualizados entrem em vigor, o USUÁRIO estará 
        vinculado a eles se continuar usando nossos produtos.
      </p>

      <p>
        Ainda, ao baixar, acessar ou utilizar os nossos produtos e aplicativos, o USUÁRIO está de acordo com o download 
        e instalação de atualizações, melhorias e recursos necessários para o contínuo funcionamento e melhoria de nossos 
        produtos.
      </p>

      <br />

      <strong>4. PROPRIEDADE INTELECTUAL</strong>

      <p>
        A ECONET permanecerá com a propriedade e titularidade de todos os direitos de propriedade intelectual, tais como patentes, 
        desenhos industriais, marcas, direitos autorais, softwares, direitos sobre informações confidenciais, sobre o seu SOFTWARE, 
        eventuais melhorias, aprimoramentos e atualizações relacionados a este, bem como a todos os demais produtos passíveis de 
        proteção pelo direito da Propriedade Intelectual.
      </p>

      <p>
        Dessa maneira, a ECONET reserva para si todos os direitos de propriedade intelectual e o uso
        de tais direitos não expressamente autorizados neste contrato. Por exemplo, esta licença
        veta e não concede nenhum direito de:
      </p>

      <ul>
        <li>
          copiar, vender, ceder, sublicenciar, publicar, copiar, alugar, virtualizar, sublicenciar,
          arrendar nem emprestar o login de acesso ao RTE;
        </li>
        <li>contornar quaisquer restrições ou limitações técnicas do RTE;</li>
        <li>fazer engenharia reversa, descompilar ou desmontar o RTE;</li>
        <li>modificar, atualizar, combinar ou criar aplicativos derivados do RTE;</li>
        <li>
          remover identificações, instruções ou quaisquer elementos do RTE ou avisos eventualmente
          constantes do RTE;
        </li>
        <li>
          buscar e/ou obter o registro de qualquer marca, designação social, nome de domínio, outros
          sinais distintivos, software, obra artística, científica, literária e/ou qualquer outro
          ativo passível de proteção pelo direito da propriedade intelectual que reproduza ou imite
          os ativos de titularidade da ECONET;
        </li>
        <li>
          usar qualquer robô, indexador, mecanismo, tecnologia, aplicativo de pesquisa/recuperação de sites ou outro dispositivo 
          para recuperar ou indexar qualquer parte das informações oriundas do RTE ou coletar informações e/ou dados sobre os 
          USUÁRIOS e/ou sobre o RTE para qualquer finalidade não autorizada; ou
        </li>
        <li>
          transmitir vírus, worms, malwares ou qualquer item que ocasione problemas no sistema ou
          perante os demais USUÁRIOS.
        </li>
      </ul>

      <br />

      <strong>5. DA VIGÊNCIA</strong>

      <p>
        Os presentes Termos e Condições de uso entram em vigência na data de seu aceite pelo USUÁRIO
        e vigorarão por prazo indeterminado, enquanto durar a utilização do RTE. Se o USUÁRIO
        excluir ou se nós desativarmos sua conta, estes Termos serão encerrados como um acordo entre
        o USUÁRIO e a ECONET, mas as disposições sobre Confidencialidade, Direitos de Propriedade
        Intelectual, e/ou que por sua natureza permaneçam vigentes após o fim da relação entre as
        partes, permanecerão em pleno vigor.
      </p>

      <br />

      <strong>6. RESPONSABILIDADE</strong>

      <p>
        A ECONET fornece produtos com o objetivo de dispor, de maneira simplificada e facilitada, a 
        cadeia tributaria de acordo com a operação simulada. PORTANTO, A INTERPRETAÇÃO DA LEGISLAÇÃO 
        E DOS PROCEDIMENTOS FISCAIS DESCRITOS SÃO DE INTEIRA RESPONSABILIDADE DO USUÁRIO, NÃO RECAINDO 
        QUALQUER RESPONSABILIDADE À ECONET QUANTO A INTERPRETAÇÕES EQUIVOCADAS OU EM DESCONFORMIDADE 
        COM O PRETENDIDO. AS INFORMAÇÕES FORNECIDAS PELA ECONET NÃO CONSTITUEM, NEM DEVEM SER CONSIDERADAS 
        COMO ACONSELHAMENTO, OPINIÃO OU CONSULTA TRIBUTÁRIA.
      </p>

      <p>
        A interpretação da legislação e dos procedimentos fiscais descritos são de INTEIRA
        RESPONSABILIDADE DO USUÁRIO, não recaindo qualquer responsabilidade à ECONET quanto
        interpretações erradas, equivocadas ou em desconformidade com o pretendido.
      </p>

      <p>
        A inserção correta de dados e informações para a pesquisa no RTE é de total e
        exclusiva responsabilidade do Usuário. Em caso de prejuízo ou dano decorrente de
        erro, falha ou omissão dessas informações durante a pesquisa, a responsabilidade
        será inteiramente do Usuário, isentando a Econet de qualquer responsabilidade.

      </p>

      <p>
        Os acessos são de responsabilidade do utilizador da ferramenta, que deve tomar as devidas
        providências para garantir a confidencialidade da mesma, sendo seu USO RESTRITO AOS
        ASSINANTES DA ECONET, e não sendo permitido o repasse quanto a sua utilização por terceiros.
        A ECONET, periodicamente realizará verificações, e caso constatado alguma irregularidade
        quanto ao seu uso, serão tomadas as devidas providências, para fins de evitar o
        compartilhamento de acesso ou vazamento de informação.
      </p>

      <p>
        A ECONET se compromete em não compartilhar as informações do USUÁRIO, de forma a respeitar
        as normas legais atinentes à matéria, respeitando as boas práticas e a governança. Porém, é
        de responsabilidade do USUÁRIO a correta utilização dos acessos, garantindo assim que o
        sistema não seja utilizado por terceiros ou de maneira a prejudicar o correto funcionamento
        do RTE.
      </p>

      <br />

      <strong>7. SEGURANÇA E GARANTIAS</strong>

      <p>
        A ECONET tem compromisso com a segurança dos dados coletados, fazendo o esforço 
        necessário para garantir a segurança e a privacidade de seus dados, sejam eles 
        relacionados ao USUÁRIO ou à utilização que faz de nossos produtos. A implementação 
        de proteções técnicas e organizacionais adequadas se dá para a proteção de processamentos 
        não-autorizados ou ilegais dos DADOS PESSOAIS e/ou SENSÍVEIS e também contra qualquer 
        invasão, perda, alteração ou vazamento não autorizado dessas informações.
      </p>

      <p>
        O RTE, cujo uso e acesso está sendo autorizado, assim o está no “estado em que se encontra”,
        não sendo imputável à ECONET quaisquer responsabilidades sobre o uso, desempenho,
        interrupção ou falhas do produto. Assim, a ECONET não será responsável pela ocorrência de
        eventuais danos aos dispositivos ou quaisquer danos diretos, indiretos, lucros cessantes,
        perda de dados, falhas em outros programas, interrupção do trabalho ou quaisquer outros
        danos causados pela instalação e/ou acesso ao RTE, haja vista que não temos como fornecer
        qualquer garantia de que o RTE funcionará de maneira sem interrupções, atrasos, imperfeições
        ou riscos de danos e/ou erros, sendo a nossa responsabilidade limitada à máxima extensão
        permitida pela legislação aplicável.
      </p>

      <p>
        Falhas, descontinuidade ou não funcionamento dos nossos produtos provenientes de 
        intervenções de terceiros, utilização irregular, e/ou advindos de descumprimento 
        de qualquer obrigação assumida pelo presente Termo e Condições de Uso, bem como 
        aqueles decorrentes de caso fortuito ou força maior, falta de conectividade e/ou 
        funcionamento anormal do dispositivo do USUÁRIO não poderá ser atribuída à ECONET.
      </p>

      <br />

      <strong>8. DA CONFIDENCIALIDADE</strong>

      <p>
        A plataforma ECONET contém INFORMAÇÕES CONFIDENCIAIS da ECONET, de seus fornecedores,
        USUÁRIOS, além de segredos do negócio. Logo, o USUÁRIO reconhece que o dever de sigilo e
        confidencialidade ora assumido deverá perdurar inclusive após o fim da relação com a ECONET
        e seus fornecedores, e abrange informações e/ou dados presentes e futuros.
      </p>

      <p>
        Nesse sentido, ao concordar com os Termos e Condições de Uso em comento, o USUÁRIO
        compromete-se a:
      </p>

      <ul>
        <li>
          a manter os critérios de sigilo e confidencialidade quando utilizar-se de INFORMAÇÕES
          CONFIDENCIAIS de propriedade e/ou relacionadas à ECONET, bem como com relação àqueles
          conteúdos, dados, informações e/ou conhecimentos decorrentes inerentes à plataforma
          ECONET, não podendo deles fazer uso senão para as específicas finalidades da execução dos
          usos permitidos pela ECONET;
        </li>
        <li>
          reconhecer que as INFORMAÇÕES CONFIDENCIAIS sobre a ECONET, seus clientes, fornecedores, 
          obras e produtos, somente podem ser utilizados para a realização do objeto deste INSTRUMENTO. 
          É terminantemente proibido revelar, armazenar, reproduzir e/ou distribuir, por qualquer 
          meio ou forma, qualquer INFORMAÇÃO CONFIDENCIAL que o USUÁRIO tenha tido acesso por conta do 
          uso do SOFTWARE;
        </li>
        <li>
          após o término da relação entre as partes, parar de usar definitivamente ditas INFORMAÇÕES
          CONFIDENCIAIS e devolver ou destruir, imediatamente, quaisquer documentos, arquivos,
          materiais, ou cópias deles, que estiverem sob sua posse e que se referiram ou contenham
          ditas INFORMAÇÕES CONFIDENCIAIS.
        </li>
      </ul>

      <p>
        As obrigações de confidencialidade e uso restrito não se aplicam caso o USUÁRIO possa
        comprovar inequivocamente que: a) a informação já era de domínio público ou que se tornou
        domínio público sem que seja por meio de violação do presente INSTRUMENTO; b) a informação
        já estava sob a sua posse anteriormente ao envio da informação pela ECONET, conforme
        evidenciado por meio de registros escritos inequívocos; c) a revelação da informação seja
        exigida por lei, regras impostas por um órgão governamental ou decisão judicial, desde que:
        i) não exista a possibilidade de adotar medidas ou recursos administrativos e judiciais; e
        ii) o USUÁRIO tenha notificado a ECONET, previamente à revelação e imediatamente após tomar
        conhecimento da necessidade de revelar, a fim de permitir que a ECONET também apresente
        medidas capazes de resguardar seus direitos.
      </p>

      <p>
        A quebra da confidencialidade estabelecida por meio deste INSTRUMENTO, devidamente
        comprovada, sem autorização expressa, possibilitará a imediata rescisão do presente. Neste
        caso, o USUÁRIO estará sujeito, por ação ou omissão, ao pagamento ou recomposição de todas
        as perdas e danos sofridos pela ECONET, os quais serão apurados em regular processo judicial
        ou administrativo.
      </p>

      <br />

      <strong>9. PROTEÇÃO DE DADOS PESSOAIS</strong>

      <p>
        O uso do aplicativo pode acarretar no TRATAMENTO de DADOS PESSOAIS, especialmente quanto
        dados comerciais e financeiros do USUÁRIO. Tais dados serão utilizados pela plataforma
        ECONET para comunicação e com propósitos operacionais relacionados ao RTE, de acordo com o
        disposto na Política de Privacidade.
      </p>

      <br />

      <strong>10. PENALIDADES</strong>

      <p>
        Na eventualidade de ocorrer o descumprimento de algumas das disposições dos Termos e
        Condições de Uso em comento, podemos remover eventual conteúdo compartilhado pelo USUÁRIO e
        que viole estas disposições e, se aplicável, podemos adotar medidas contra sua conta.
        Podemos também desativar sua conta se o USUÁRIO vier a reincidir na prática de violação dos
        presentes Termos e Condições de Uso, ou se incorrer na prática de violações graves, como é
        caso de infrações que envolvam INFORMAÇÕES CONFIDENCIAIS, DADOS SENSÍVEIS, DADOS PESSOAIS ou
        Direitos de Propriedade Intelectual.
      </p>

      <p>
        Como USUÁRIO da plataforma RTE, reconhece que a violação a qualquer dispositivo destes
        Termos e Condições que implique no descumprimento às regras para utilização das INFORMAÇÕES
        CONFIDENCIAIS da RTE, não apenas representa infração contratual grave à relação havida entre
        a ECONET e o USUÁRIO, dando ensejo, de pleno direito, à resolução de todos os contratos
        celebrados existentes, sem prejuízo do pagamento, ou recomposição, de todas as perdas e
        danos incorridos pela ECONET, como também caracteriza crime de concorrência desleal,
        tipificado no artigo 195 da Lei 9.279/96, sem prejuízo de eventual responsabilização por
        crimes contra a inviolabilidade dos segredos, conforme artigos 153 e 154 do Código Penal
        e/ou outras sanções de caráter civil e criminal, a serem apuradas em regular processo
        judicial e/ou administrativo.
      </p>

      <br />

      <strong>11. DA LEI APLICÁVEL E JURISDIÇÃO</strong>

      <p>
        Estes Termos e Condições de Uso são regidos e interpretados em conformidade com as Leis do
        Brasil. A ECONET e o USUÁRIO desde logo elegem, de forma irrevogável e irretratável, o foro
        da Comarca da Cidade de Curitiba, Estado do Paraná para dirimir quaisquer dúvidas ou
        controvérsias oriundas deste INSTRUMENTO, com a exclusão de qualquer outro, por mais
        privilegiado que seja.
      </p>

      <br />

      <strong>12. DISPOSIÇÕES GERAIS</strong>

      <p>
        Adicionalmente ao disposto na Política de Privacidade, estes Termos e Condições de Uso
        constituem um acordo integral entre o USUÁRIO e a ECONET, concernente a seu objeto,
        substituindo quaisquer representações, negociações ou entendimentos anteriores.
      </p>

      <p>
        A utilização da RTE pelo USUÁRIO e a concordância com os presentes Termos e Condições não
        implica em nenhuma espécie de sociedade, associação, solidariedade obrigacional, nem em
        qualquer responsabilidade direta ou indireta, seja societária, comercial, tributária,
        trabalhista, previdenciária ou de qualquer outra natureza, nem em alienação ou sucessão,
        entre a ECONET e o USUÁRIO.
      </p>

      <p>
        A omissão ou tolerância por parte da ECONET, em exigir o estrito cumprimento das disposições
        e condições deste Termo, não constituirá novação ou renúncia, nem afetará os seus direitos,
        que poderão ser exercidos a qualquer tempo.
      </p>

      <p>
        Estes Termos e Condições de Uso vinculam e asseguram o benefício das partes e de seus
        sucessores, cessionários, licenciados, herdeiros e empresas associadas, a qualquer título,
        em todas as suas cláusulas e condições.
      </p>

      <p>
        Ao concordar com os Termos e Condições de Uso, o USUÁRIO declara e concorda que:
      </p>

      <ul>
        <li>
          Está de acordo com o recebimento de envio de mensagens eletrônicas para o seu 
          endereço do e-mail e/ou número do telefone celular (SMS, MMS ou via aplicativos 
          de comunicação, como o <i>Whatsapp</i>), incluindo serviços de “push” e outros 
          meios necessários a execução dos produtos contratados;
        </li>
        <li>
          Na melhor forma de direito que na celebração deste instrumento, não houve lesão, dolo,
          coação física ou moral, erro e nenhum outro vício de consentimento que possa afetar a sua
          existência ou validade, estando as partes em total conformidade com os termos e condições
          neste ato ajustadas.
        </li>
      </ul>

      <p>
        Se qualquer cláusula e/ou disposição destes Termos e Condições de Uso tornar-se total ou
        parcialmente inválida, ilegal, inexequível ou omissa, nos termos da lei aplicável, tal
        condição não prejudicará a validade das demais cláusulas e condições dos presentes Termos e
        Condições de Uso, que continuarão em pleno vigor e efeito. Em qualquer hipótese, a ECONET
        irá envidar seus melhores esforços para substituir a cláusula e/ou disposição inválida,
        ilegal, inexequível ou omissa, por outra de conteúdo similar e com os mesmos efeitos. A
        alteração e/ou atualização do presente INSTRUMENTO será objeto de comunicado por parte da
        ECONET.
      </p>

      <br />

      <strong>DA ACEITAÇÃO DO TERMO DE USO</strong>

      <p>
        Ao aceitar o Termo de Uso, o USUÁRIO declara ter lido, compreendido e confirma estar de
        acordo com todas as regras, condições e obrigações estabelecidas no presente INSTRUMENTO.
      </p>
    </div>
    <template slot="modal-footer">
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Aceitar"
        icone="check"
        :click="handleClick"
        cor="azul"
      />
    </template>
  </b-modal>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

import Api from "@/services/api.js";
import { mapActions } from "vuex";

export default {
  name: "ModalTermos",
  components: {
    BotaoPadrao,
    Header,
    LoadingPadraoContainer
  },
  data() {
    return {
      loadingTermos: false
    };
  },
  created() {
    window.addEventListener("keydown", this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },
  methods: {
    ...mapActions("login", ["setPrimeiroLogin"]),
    async handleKey(event) {
      let modal = document.getElementById("ModalTermos");
      if (modal.classList.contains("show")) {
        if (event.key === "Enter") {
          await this.handleClick();
        }
      }
    },
    async handleClick() {
      this.loadingTermos = true;
      await new Api().get("Login/SalvarAceiteTermo");
      this.setPrimeiroLogin(false);
      this.loadingTermos = false;
      this.$root.$emit("bv::hide::modal", "ModalTermos");
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-termos-corpo {
  max-height: calc(100vh - 280px);
  overflow-y: scroll;
  padding-right: 14px;
  text-align: justify;
}
</style>
